export default __webpack_public_path__ + "static/media/SMART.7e21445b.png";